import { notificationFilterById } from "actions/Utilities/NotificationFilter";
import AddButton from "components/AddButton";
import ConfirmBoxDeleteTS from "components/ConfirmBoxDeleteTS";
import ConfirmBoxModalTS from "components/ConfirmBoxModalTS";
import EditButton from "components/EditButton";
import MaterialTableTS from "components/tables/MaterialTableTS";
import { toast } from "components/toastNotification";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import TableFilters from "../TableFilters";
import { FeeLevelType, recordIdType } from "../types";
import {
  addStateFeeLevelFeeLevel,
  editStateFeeLevel,
  rowEditIdStateFeeLevel,
  selectedRowsStateFeeLevel,
  setFilterTextFeeLevel,
} from "./atoms/atoms";
import { FeeLevelForm } from "./forms/FeeLevelForm";
import useDeleteFeeLevel from "./hooks/useDeleteFeeLevel";
import useFeeLevel from "./hooks/useFeeLevel";
import useUpdateFeeLevel from "./hooks/useUpdateFeeLevel";

const FeeLevelTable = () => {
  //Hooks Call
  const { data, isFetching } = useFeeLevel();
  const UpdateFeeLevel = useUpdateFeeLevel();
  const BulkDeleteFeeLevelType = useDeleteFeeLevel();
  //Atoms Call
  const [editData, setEditData] = useRecoilState(rowEditIdStateFeeLevel);
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateFeeLevelFeeLevel
  );
  const [editFeeState, setEditFeeState] = useRecoilState(editStateFeeLevel);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateFeeLevel
  );

  const [rowsCount, setRowsCount] = useState(0);
  const [filterText, setFilterText] = useRecoilState(setFilterTextFeeLevel);
  //Local States
  const [empTypeIsExist, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [hideColumn, setHideColumn] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [FeeLevelFilteredData, setFeeLevelFilteredData] = useState<
    FeeLevelType[]
  >([]);

  const addPermission =
    PERMISSIONS.permission_utilities_policyterm_feelevel_add;
  const editPermission =
    PERMISSIONS.permission_utilities_policyterm_feelevel_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_policyterm_feelevel_delete;

  const userPermissions = useRecoilValue(permissionsSelector);

  const [empNewData] = useState<FeeLevelType[]>([]);

  //For filtered data update
  const [feeLevelId, setFeeLevelId] = useState("");
  useEffect(() => {
    if (feeLevelId?.includes(".")) {
      let ids = feeLevelId.split(".");
      const arr = ids.map((id) => Number(id));
      const filteredData = data?.filter((x) => arr.includes(x.feeLevelId));
      setFeeLevelFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.feeLevelId === Number(feeLevelId)
      );
      setFeeLevelFilteredData(filteredData);
    }
  }, [feeLevelId, data]);

  let recordIdFromRecent: recordIdType;
  let location = useLocation();
  const history = useHistory();

  if (location.state != null) {
    recordIdFromRecent!.locationState = location.state! as string;
  }
  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setFeeLevelFilteredData(result);
          setFeeLevelId(recordIdFromRecent.recordId);
          history.replace("");
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setEditFeeState(false);
    setSelectedRows([]);
    setEditData(null);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  const handleEditButton = (rowData) => {
    setEditData({
      ...rowData,
    });

    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.feeLevelId = rowData.feeLevelId));
    empNewData.map((x) => (x.feeLevelName = rowData.feeLevelName));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.createdDate = rowData.createdDate));
  };

  //Save changes
  const handleSave = (empNewData) => {
    if (empTypeDataIsChange) {
      if (!empTypeIsExist) {
        if (empNewData.filter((x) => x.feeLevelName) !== "") {
          UpdateFeeLevel(empNewData);
          setEditData(null);
          setSelectedRows([]);
          setEmpTypeIsExistState(false);
          setEmpTypeDataIsChange(false);
          setOpenModalEdit(false);
          setEditFeeState(false);
          setDisabledButton(false);
          setHideColumn(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModalEdit(false);
        }
      } else {
        toast.fire("Saving Failed", "Fee Level Type already exists!", "error");
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditData(null);
      setOpenModalEdit(false);
      setEmpTypeDataIsChange(false);
      setEditFeeState(false);
      setDisabledButton(false);
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.feeLevelId);
    BulkDeleteFeeLevelType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Fee Levels" : "Fee Level"
    }?`}</div>
  );

  useEffect(() => {
    if (!editData) {
      setDisabledButton(false);
      setHideColumn(false);
    }
  }, [editData]);

  const matColumns = [
    {
      title: "Fee Level Name",
      field: "feeLevelName",
      customSort: (a, b) =>
        a.feeLevelName && b.feeLevelName
          ? a.feeLevelName.trim().localeCompare(b.feeLevelName.trim())
          : a.feeLevelName
          ? 0
          : -1,
      render: (rowData) => {
        return (
          <span className="text-quinary font-bold uppercase text-sm">
            {rowData.feeLevelName}
          </span>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      type: "date" as "date",
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      customSort: (a, b) =>
        a.createdBy && b.createdBy
          ? a.createdBy.trim().localeCompare(b.createdBy.trim())
          : a.createdBy
          ? 0
          : -1,
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      type: "date" as "date",
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      customSort: (a, b) =>
        a.modifiedBy && b.modifiedBy
          ? a.modifiedBy.trim().localeCompare(b.modifiedBy.trim())
          : a.modifiedBy
          ? 0
          : -1,
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return (
          <div className="font-sans uppercase mr-4 text-xs">
            {rowData.isActive ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      sorting: false,
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : (
          <div className=" flex items-center place-content-center">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setEditFeeState(true);
                setDisabledButton(true);
                handleEditButton(rowData);
                setHideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const filteredItems = data
    ? data.filter(
        (item) =>
          item.feeLevelName &&
          item.feeLevelName
            .toLowerCase()
            .includes(filterText?.trim().toLowerCase())
      )
    : [];

  const editOrAdd = actionAddState || editFeeState;

  return (
    <div className="bg-white animate-fade-in-down p-4">
      {!editOrAdd && (
        <>
          <div className="flex flex-row">
            <div className="w-1/2">
              <TableFilters
                defaultValue={filterText}
                filterText={setFilterText}
                moduleDetails="FeeLevel"
                textInputName="FeeLevelName"
                columnDetails="Fee Level Name"
                disabledButton={disabledButton || selectedRows.length > 0}
              ></TableFilters>
            </div>
            <div className="w-1/2">
              {!userPermissions.includes(addPermission) ? (
                ""
              ) : (
                <AddButton
                  buttonText="New Fee Level"
                  className={
                    selectedRows.length > 0 || editFeeState
                      ? "opacity-50 float-right"
                      : "opacity-100 float-right"
                  }
                  onClick={() => setActionAddState(!actionAddState)}
                  disabled={disabledButton || selectedRows.length > 0}
                />
              )}
            </div>
          </div>

          <div>
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>

          <div className="">
            <MaterialTableTS
              columns={matColumns as any}
              data={
                data
                  ? FeeLevelFilteredData?.length > 0
                    ? FeeLevelFilteredData
                    : filterText === ""
                    ? data
                    : filteredItems
                  : []
              }
              isLoading={isFetching}
              selection={
                !editFeeState && userPermissions.includes(deletePermission)
              }
              onSelectionChange={handleSelectedRowsChange}
              selectedRows={selectedRows}
              setConfirmModalOpen={setOpenModalDelete}
              showTitle={true}
            />
          </div>

          <ConfirmBoxModalTS
            ModalTitle="Update Fee Level"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              setHideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDeleteTS
            ModalTitle="Deactivate Fee Level"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </>
      )}
      {editOrAdd && (
        <div className="">
          <FeeLevelForm />
        </div>
      )}
    </div>
  );
};

export default FeeLevelTable;
